// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".right-arrow {\n  position: absolute;\n  right: 15px;\n  color: #0066cc;\n}\n", "",{"version":3,"sources":["webpack://src/pages/qrReading/QrPackageTrack.less"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB","sourcesContent":[".right-arrow {\n  position: absolute;\n  right: 15px;\n  color: #0066cc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
